module.exports = __webpack_public_path__ + "assets/images/card-pg-5_e37e9aa1a5a42637ccf0291ece436301.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/card-pg-5.png
// module id = 192
// module chunks = 0